import { useState } from "react";
import { OrderReference } from "$types/OrderReference";
import { ProductReferenceList } from "$types/ProductReferenceList";

function usePreviousReferencings() {
  const [previousOrderRefs, setPreviousOrderRefs] = useState<OrderReference[]>(
    []
  );
  const [previousProductListRefs, setPreviousProductListRefs] = useState<
    ProductReferenceList[]
  >([]);

  const findPreviousProductListRefIdx = (
    productReferenceList: ProductReferenceList
  ) => {
    return previousProductListRefs.findIndex(
      (pr) =>
        // product referencing is about only one suborder
        productReferenceList.suborders[0].reference ===
        pr.suborders[0].reference
    );
  };

  const findPreviousOrderRefIdx = (orderRef: OrderReference) => {
    return previousOrderRefs.findIndex(
      (pr) => pr.suborders[0].reference === orderRef.suborderReferences[0]
    );
  };

  const deletePreviousOrderRef = (orderRef: OrderReference) => {
    const previousRefIdx = findPreviousOrderRefIdx(orderRef);
    if (previousRefIdx !== -1) {
      setPreviousOrderRefs(
        previousOrderRefs.filter((pr, idx) => idx !== previousRefIdx)
      );
    }
  };

  const deletePreviousProductListRef = (pRefList: ProductReferenceList) => {
    const previousRefIdx = findPreviousProductListRefIdx(pRefList);
    if (previousRefIdx !== -1) {
      setPreviousProductListRefs(
        previousProductListRefs.filter((pr, idx) => idx !== previousRefIdx)
      );
    }
  };

  const addToPreviousOrderRefs = (orderRef: OrderReference) => {
    setPreviousOrderRefs([...previousOrderRefs, orderRef]);
  };
  const addToPreviousProductListRefs = (pRefList: ProductReferenceList) => {
    setPreviousProductListRefs([...previousProductListRefs, pRefList]);
  };

  const getPreviousOrderRefFromProductList = (
    productRefList: ProductReferenceList
  ): OrderReference => {
    return previousOrderRefs.find(
      (or) =>
        or.suborderReferences.length === 1 &&
        // product referencing is about only one suborder
        productRefList.suborders[0].reference === or.suborderReferences[0]
    );
  };

  const getPreviousProductListFromOrderRef = (
    orderRef: OrderReference
  ): ProductReferenceList => {
    const { suborderReferences } = orderRef;
    return previousProductListRefs.find(
      (pr) => pr.suborders[0].reference === suborderReferences[0]
    );
  };

  return {
    addToPreviousOrderRefs,
    addToPreviousProductListRefs,
    deletePreviousOrderRef,
    deletePreviousProductListRef,
    getPreviousOrderRefFromProductList,
    getPreviousProductListFromOrderRef,
  };
}

export default usePreviousReferencings;
